import { IconDownload } from '@veneer/core';
import {
  ModalPrinterComparisonAnalyticsPayload,
  ProductInfo,
  ProductSpecs,
} from './types';
import {
  FeatureDescription,
  FeatureNameSpecs,
  FeatureNameText,
  FeatureNone,
  FeatureUnitSpecs,
} from './styles';
interface PrinterSpecProps {
  printer: ProductInfo;
  fullSpecsLabel: string;
  onAnalytics?: (data: ModalPrinterComparisonAnalyticsPayload) => void;
}

const PrinterSpec: React.FC<PrinterSpecProps> = ({
  printer,
  fullSpecsLabel,
  onAnalytics,
}) => {
  const printerSpecs = printer.specs || ({} as ProductSpecs);

  if (!printerSpecs.url) {
    return (
      <FeatureUnitSpecs>
        <FeatureNone
          style={{ marginBottom: '14px' }}
          data-testid="feature-none"
        />
      </FeatureUnitSpecs>
    );
  }

  const handleClick = () => {
    if (onAnalytics) {
      onAnalytics({
        controlName: printerSpecs.controlName,
        controlDetail: printerSpecs.originalUrl
          ? printerSpecs.originalUrl
          : printerSpecs.url,
      });
    }
  };

  return (
    <FeatureUnitSpecs>
      <FeatureNameSpecs
        className="caption-regular"
        href={printerSpecs.url}
        target="_blank"
        id={printerSpecs.controlName}
        rel="noopener noreferrer"
        data-testid="fullSpecsLink"
        onClick={() => handleClick()}
      >
        <IconDownload size={20} color="royalBlue7" />
        <FeatureNameText className="caption-regular">
          {fullSpecsLabel}
        </FeatureNameText>
      </FeatureNameSpecs>
      <FeatureDescription className="caption-regular">
        {printerSpecs.description}
      </FeatureDescription>
    </FeatureUnitSpecs>
  );
};

export default PrinterSpec;
